import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Signup() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);
        try {
            const API_BASE = process.env.REACT_APP_API_URL || '';
            const res = await fetch(`${API_BASE}/api/auth/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, password })
            });
            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || 'שגיאה בהרשמה');
            }

            setSuccess('נרשמת בהצלחה! שלחנו לך אימייל עם קישור לאימות חובה. נא בדוק את תיבת הדואר הנכנס שלך (וגם את תיקיית הספאם).');
            setName(''); setEmail(''); setPassword('');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center relative overflow-hidden" dir="rtl"
            style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)' }}>

            {/* Animated background shapes */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-40 -left-40 w-80 h-80 rounded-full opacity-10"
                    style={{ background: 'radial-gradient(circle, #3b82f6 0%, transparent 70%)', animation: 'pulse 4s ease-in-out infinite' }}></div>
                <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full opacity-10"
                    style={{ background: 'radial-gradient(circle, #60a5fa 0%, transparent 70%)', animation: 'pulse 6s ease-in-out infinite reverse' }}></div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-5"
                    style={{ background: 'radial-gradient(circle, #93c5fd 0%, transparent 60%)', animation: 'pulse 8s ease-in-out infinite' }}></div>
            </div>

            {/* Signup Card */}
            <div className="relative z-10 w-full max-w-md mx-4">
                {/* Glass Card */}
                <div className="backdrop-blur-xl rounded-3xl p-8 md:p-10 border border-white/10 shadow-2xl"
                    style={{ background: 'rgba(255,255,255,0.05)' }}>

                    {/* Branding */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5 shadow-lg"
                            style={{ background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)' }}>
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                    d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-black text-white uppercase tracking-tight">
                            הגש בקשת הצטרפות
                        </h1>
                        <p className="text-slate-400 text-xs mt-2 uppercase tracking-widest font-medium">
                            Alum Nawatha LTD
                        </p>
                    </div>

                    {/* Messages */}
                    {error && (
                        <div className="mb-6 p-4 rounded-2xl text-sm font-semibold text-center border border-red-500/30"
                            style={{ background: 'rgba(239,68,68,0.1)', color: '#fca5a5' }}>
                            {error}
                        </div>
                    )}
                    {success && (
                        <div className="mb-6 p-4 rounded-2xl text-sm font-semibold text-center border border-green-500/30"
                            style={{ background: 'rgba(34,197,94,0.1)', color: '#86efac' }}>
                            {success}
                        </div>
                    )}

                    {/* Signup Form */}
                    {!success && (
                        <form onSubmit={handleSubmit} className="space-y-5">
                            <div>
                                <label className="block text-slate-400 text-[10px] uppercase tracking-widest font-bold mb-2">
                                    שם מלא / עסק
                                </label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                    autoFocus
                                    placeholder="שם העסק שלך"
                                    className="w-full px-5 py-4 rounded-2xl text-white placeholder-slate-500 border border-white/10 outline-none transition-all duration-300 focus:border-blue-500/50 focus:ring-2 focus:ring-blue-500/20"
                                    style={{ background: 'rgba(255,255,255,0.05)' }}
                                />
                            </div>
                            <div>
                                <label className="block text-slate-400 text-[10px] uppercase tracking-widest font-bold mb-2">
                                    כתובת אימייל
                                </label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    placeholder="name@example.com"
                                    dir="ltr"
                                    className="w-full px-5 py-4 rounded-2xl text-white placeholder-slate-500 border border-white/10 outline-none transition-all duration-300 focus:border-blue-500/50 focus:ring-2 focus:ring-blue-500/20"
                                    style={{ background: 'rgba(255,255,255,0.05)' }}
                                />
                            </div>
                            <div>
                                <label className="block text-slate-400 text-[10px] uppercase tracking-widest font-bold mb-2">
                                    סיסמה
                                </label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    minLength={6}
                                    autoComplete="new-password"
                                    placeholder="Enter password"
                                    dir="ltr"
                                    className="w-full px-5 py-4 rounded-2xl text-white placeholder-slate-500 border border-white/10 outline-none transition-all duration-300 focus:border-blue-500/50 focus:ring-2 focus:ring-blue-500/20"
                                    style={{ background: 'rgba(255,255,255,0.05)' }}
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full py-4 rounded-2xl font-black uppercase text-white text-sm tracking-widest transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed mt-2"
                                style={{ background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)' }}
                            >
                                {loading ? (
                                    <span className="inline-flex items-center gap-2">
                                        <svg className="w-4 h-4 animate-spin text-white" viewBox="0 0 24 24" fill="none">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                        </svg>
                                        מעבד בקשה...
                                    </span>
                                ) : 'צור חשבון באזור המקצועי'}
                            </button>
                        </form>
                    )}

                    <div className="text-center mt-8 pt-6 border-t border-white/10">
                        <p className="text-slate-400 text-xs font-medium">
                            כבר רשום כבעל מקצוע?{' '}
                            <Link to="/login" className="text-blue-400 font-bold hover:text-blue-300 transition-colors">
                                התחבר כאן
                            </Link>
                        </p>
                    </div>
                </div>

                <p className="text-center text-slate-600 text-[9px] uppercase tracking-widest mt-6">
                    &copy; {new Date().getFullYear()} Alum Nawatha Aluminum Industry
                </p>
            </div>

            {/* Inline keyframe for pulse animation */}
            <style>{`
                @keyframes pulse {
                    0%, 100% { transform: scale(1); opacity: 0.1; }
                    50% { transform: scale(1.2); opacity: 0.15; }
                }
            `}</style>
        </div>
    );
}
